import React from 'react';
import DateSeparator from "@/app/components/date-separator";
import UserMessage from "@/app/components/user-message";
import AiMessage from "@/app/components/AiMessage";
import { MessageStore } from "@/services/models/messageStore";

interface MessagesWithDateSeparatorsProps {
    messages: MessageStore[];
    messagesEndRef?: React.RefObject<HTMLDivElement | null>;
    onDisplayIframe?: (messageId: number) => void;
    displayedIframeId?: number | null;
    style?: React.CSSProperties;
    useVoteMutation?: any;
    showAvatars?: boolean;
    compactMobileSpacing?: boolean;
}

const MessagesWithDateSeparators: React.FC<MessagesWithDateSeparatorsProps> = ({
                                                                                   messages,
                                                                                   messagesEndRef,
                                                                                   onDisplayIframe,
                                                                                   displayedIframeId,
                                                                                    style,
                                                                                    useVoteMutation,
                                                                                    showAvatars = true,
                                                                                    compactMobileSpacing = false
                                                                               }) => {
    if (!messages.length) return null;

    const renderMessagesWithSeparators = (): React.ReactNode[] => {
        const result: React.ReactNode[] = [];
        let lastMessageDate: string | null = null;

        messages.forEach((message, index) => {
            const currentDate = new Date(message.time);
            const currentDateString = currentDate.toDateString();

            if (index === 0 || currentDateString !== lastMessageDate) {
                result.push(
                    <DateSeparator
                        key={`date-${currentDateString}-${index}`}
                        date={currentDate}
                    />
                );
                lastMessageDate = currentDateString;
            }

            const uniqueKey = message.id && message.id !== -1
                ? `msg-${message.id}`
                : `temp-msg-${index}`;

            result.push(
                <div key={uniqueKey} className="w-full overflow-x-hidden">
                    {message.type === 'ai' ? (
                        <AiMessage
                            content={message}
                            isVotingAvailable={true}
                            onDisplayIframe={onDisplayIframe}
                            displayedIframeId={displayedIframeId}
                            useVoteMutation={useVoteMutation}
                            showAvatar={showAvatars}
                            compactMobileSpacing={compactMobileSpacing}
                        />
                    ) : (
                        <UserMessage
                            content={message.message}
                            images={message.images}
                            timestamp={message.time.toString()}
                            compactMobileSpacing={compactMobileSpacing}
                        />
                    )}
                </div>
            );
        });

        return result;
    };

    return (
        <div 
            className={`mx-auto ${compactMobileSpacing ? 'px-2' : 'px-0'} md:px-4 ${compactMobileSpacing ? 'py-2 md:py-4 space-y-3 md:space-y-6' : 'py-4 space-y-6'} w-full`}
            style={style == null ? {maxWidth: compactMobileSpacing ? "95%" : "60%"}: style}>
            {renderMessagesWithSeparators()}
            {messagesEndRef && <div ref={messagesEndRef} />}
        </div>
    );
};

export default MessagesWithDateSeparators;